import React from 'react';
import { NavBarLinks } from './NavBarLinks';

/**
 * @file SideNavBar.tsx
 * @brief Seitliche Navigationsleiste der Anwendung.
 *
 * Diese Komponente stellt eine vertikale Navigationsleiste mit Links zu verschiedenen Bereichen der Anwendung bereit.
 * Einige Links sind nur für Benutzer mit der Rolle 'admin' sichtbar.
 *
 * @returns {JSX.Element} Ein React-Element, das die seitliche Navigationsleiste darstellt.
 */
const SideNavBar = () => {
  return (
    <div className="side-nav-bar">
      <h2 className="ms-3">Menü</h2>
      <ul className="nav flex-column">
        <NavBarLinks isBottomNav={false} />
      </ul>
    </div>
  );
};

export default SideNavBar;
